var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "99.449 75.827 20 20",
    width: "20px",
    height: "20px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2369_2060",
    x1: -0.362867,
    y1: 10.443,
    x2: 20.326,
    y2: 10.443,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1, 0, 0, 1, 99.448822, 75.803352)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#895EF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F03063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7640"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 105.424 90.827 L 109.449 89.002 L 113.474 90.827 L 113.849 90.452 L 109.449 79.827 L 105.049 90.452 L 105.424 90.827 Z M 109.449 95.827 C 108.065 95.827 106.765 95.564 105.549 95.039 C 104.332 94.514 103.274 93.802 102.374 92.902 C 101.474 92.002 100.761 90.943 100.236 89.727 C 99.711 88.51 99.449 87.21 99.449 85.827 C 99.449 84.443 99.711 83.143 100.236 81.927 C 100.761 80.71 101.474 79.652 102.374 78.752 C 103.274 77.852 104.332 77.139 105.549 76.614 C 106.765 76.089 108.065 75.827 109.449 75.827 C 110.832 75.827 112.132 76.089 113.349 76.614 C 114.566 77.139 115.624 77.852 116.524 78.752 C 117.424 79.652 118.136 80.71 118.661 81.927 C 119.186 83.143 119.449 84.443 119.449 85.827 C 119.449 87.21 119.186 88.51 118.661 89.727 C 118.136 90.943 117.424 92.002 116.524 92.902 C 115.624 93.802 114.566 94.514 113.349 95.039 C 112.132 95.564 110.832 95.827 109.449 95.827 Z M 109.449 93.827 C 111.682 93.827 113.574 93.052 115.124 91.502 C 116.674 89.952 117.449 88.06 117.449 85.827 C 117.449 83.593 116.674 81.702 115.124 80.152 C 113.574 78.602 111.682 77.827 109.449 77.827 C 107.215 77.827 105.324 78.602 103.774 80.152 C 102.224 81.702 101.449 83.593 101.449 85.827 C 101.449 88.06 102.224 89.952 103.774 91.502 C 105.324 93.052 107.215 93.827 109.449 93.827 Z",
    fill: "url(#paint0_linear_2369_2060)",
    id: "object-0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigation);
export default __webpack_public_path__ + "static/media/navigation.57bf629071da01e262994e213e9ec94a.svg";
export { ForwardRef as ReactComponent };